import defaultSettings from '@/config/settings'

const title = defaultSettings.title || '剑桥全球英语'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
